(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b4v9R", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $80f83cca1ea11c6d$export$6503ec6e8aabbaf; }, function (v) { return $80f83cca1ea11c6d$export$6503ec6e8aabbaf = v; });
var $80f83cca1ea11c6d$export$6503ec6e8aabbaf;
var $80f83cca1ea11c6d$export$f7ad0328861e2f03;
"use strict";
var $80f83cca1ea11c6d$var$mapping = new Map();
function $80f83cca1ea11c6d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$80f83cca1ea11c6d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $80f83cca1ea11c6d$var$resolve(id) {
    var resolved = $80f83cca1ea11c6d$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$80f83cca1ea11c6d$export$6503ec6e8aabbaf = $80f83cca1ea11c6d$var$register;
$80f83cca1ea11c6d$export$f7ad0328861e2f03 = $80f83cca1ea11c6d$var$resolve;

});

parcelRegister("4h0xY", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $31c92c8c4a48273e$export$bdfd709ae4826697; }, function (v) { return $31c92c8c4a48273e$export$bdfd709ae4826697 = v; });
var $31c92c8c4a48273e$export$bdfd709ae4826697;
var $31c92c8c4a48273e$export$c9e73fbda7da57b6;
var $31c92c8c4a48273e$export$5a759dc7a1cfb72a;
"use strict";
var $31c92c8c4a48273e$var$bundleURL = {};
function $31c92c8c4a48273e$var$getBundleURLCached(id) {
    var value = $31c92c8c4a48273e$var$bundleURL[id];
    if (!value) {
        value = $31c92c8c4a48273e$var$getBundleURL();
        $31c92c8c4a48273e$var$bundleURL[id] = value;
    }
    return value;
}
function $31c92c8c4a48273e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $31c92c8c4a48273e$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $31c92c8c4a48273e$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $31c92c8c4a48273e$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$31c92c8c4a48273e$export$bdfd709ae4826697 = $31c92c8c4a48273e$var$getBundleURLCached;
$31c92c8c4a48273e$export$c9e73fbda7da57b6 = $31c92c8c4a48273e$var$getBaseURL;
$31c92c8c4a48273e$export$5a759dc7a1cfb72a = $31c92c8c4a48273e$var$getOrigin;

});

var $64a10eeab26a8b4b$exports = {};


(parcelRequire("b4v9R")).register((parcelRequire("4h0xY")).getBundleURL('ju1jN'), JSON.parse("[\"ju1jN\",\"index.03ddc4c1.js\",\"d8FhJ\",\"amazon_icon.637b370d.svg\",\"9bThM\",\"archive_icon.b93ca50a.svg\",\"9vSOQ\",\"generic_link_icon.3aa6c58d.svg\",\"7pmEE\",\"king-james-bible-kjv.ddcb2585.png\",\"03F49\",\"king-james-bible-online.46b885d6.png\",\"d6OM5\",\"kjv-logo.14aaa2a7.png\",\"eKLoI\",\"open-bible.d0b47fbd.png\",\"4N1lc\",\"opengraph_banner.c6e2d394.png\",\"3YYbI\",\"typesense.3867b908.svg\",\"hMbBr\",\"index.22fbd6e4.js\"]"));


var $isndi = parcelRequire("isndi");
parcelRequire("4Wdhx");

var $dZhcI = parcelRequire("dZhcI");

var $ieTBU = parcelRequire("ieTBU");
var $emBps = parcelRequire("emBps");
var $6UOpb = parcelRequire("6UOpb");
var $2hZw3 = parcelRequire("2hZw3");
var $gMP3i = parcelRequire("gMP3i");

var $gmem3 = parcelRequire("gmem3");

var $aWzhI = parcelRequire("aWzhI");

var $eG8tq = parcelRequire("eG8tq");
var $b01gv = parcelRequire("b01gv");
var $f3bh9 = parcelRequire("f3bh9");
function $de57eda7dc6cba5d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $de57eda7dc6cba5d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $de57eda7dc6cba5d$var$_typeof(obj);
}
function $de57eda7dc6cba5d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $de57eda7dc6cba5d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $de57eda7dc6cba5d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $de57eda7dc6cba5d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $de57eda7dc6cba5d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $de57eda7dc6cba5d$var$_defineProperty(obj, key, value) {
    key = $de57eda7dc6cba5d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $de57eda7dc6cba5d$var$_toPropertyKey(arg) {
    var key = $de57eda7dc6cba5d$var$_toPrimitive(arg, "string");
    return $de57eda7dc6cba5d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $de57eda7dc6cba5d$var$_toPrimitive(input, hint) {
    if ($de57eda7dc6cba5d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($de57eda7dc6cba5d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $de57eda7dc6cba5d$var$withUsage = (0, $b01gv.createDocumentationMessageGenerator)({
    name: 'search-box',
    connector: true
});
/**
 * @typedef {Object} CustomSearchBoxWidgetParams
 * @property {function(string, function(string))} [queryHook = undefined] A function that will be called every time
 * a new value for the query is set. The first parameter is the query and the second is a
 * function to actually trigger the search. The function takes the query as the parameter.
 *
 * This queryHook can be used to debounce the number of searches done from the searchBox.
 */ var $de57eda7dc6cba5d$var$defaultQueryHook = function defaultQueryHook(query, hook) {
    return hook(query);
};
/**
 * **SearchBox** connector provides the logic to build a widget that will let the user search for a query.
 *
 * The connector provides to the rendering: `refine()` to set the query. The behaviour of this function
 * may be impacted by the `queryHook` widget parameter.
 */ var $de57eda7dc6cba5d$var$connectSearchBox = function connectSearchBox(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $f3bh9.noop);
    (0, $eG8tq.checkRendering)(renderFn, $de57eda7dc6cba5d$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$queryHook = _ref.queryHook, queryHook = _ref$queryHook === void 0 ? $de57eda7dc6cba5d$var$defaultQueryHook : _ref$queryHook;
        var _refine;
        var _clear;
        return {
            $$type: 'ais.searchBox',
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($de57eda7dc6cba5d$var$_objectSpread($de57eda7dc6cba5d$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($de57eda7dc6cba5d$var$_objectSpread($de57eda7dc6cba5d$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref2) {
                var state = _ref2.state;
                unmountFn();
                return state.setQueryParameter('query', undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $de57eda7dc6cba5d$var$_objectSpread($de57eda7dc6cba5d$var$_objectSpread({}, renderState), {}, {
                    searchBox: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref3) {
                var helper = _ref3.helper, instantSearchInstance = _ref3.instantSearchInstance, state = _ref3.state;
                if (!_refine) {
                    _refine = function _refine(query) {
                        queryHook(query, function(q) {
                            return helper.setQuery(q).search();
                        });
                    };
                    _clear = function _clear() {
                        helper.setQuery('').search();
                    };
                }
                return {
                    query: state.query || '',
                    refine: _refine,
                    clear: _clear,
                    widgetParams: widgetParams,
                    isSearchStalled: instantSearchInstance.status === 'stalled'
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var query = searchParameters.query || '';
                if (query === '' || uiState && uiState.query === query) return uiState;
                return $de57eda7dc6cba5d$var$_objectSpread($de57eda7dc6cba5d$var$_objectSpread({}, uiState), {}, {
                    query: query
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                return searchParameters.setQueryParameter('query', uiState.query || '');
            }
        };
    };
};
var $de57eda7dc6cba5d$export$2e2bcd8739ae039 = $de57eda7dc6cba5d$var$connectSearchBox;



var $8Deqe = parcelRequire("8Deqe");

var $b01gv = parcelRequire("b01gv");
var $aCMjd = parcelRequire("aCMjd");

var $551Ac = parcelRequire("551Ac");
function $98496c826aa59477$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $98496c826aa59477$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $98496c826aa59477$var$_typeof(obj);
}
function $98496c826aa59477$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $98496c826aa59477$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $98496c826aa59477$var$ownKeys(Object(source), !0).forEach(function(key) {
            $98496c826aa59477$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $98496c826aa59477$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $98496c826aa59477$var$_defineProperty(obj, key, value) {
    key = $98496c826aa59477$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $98496c826aa59477$var$_toPropertyKey(arg) {
    var key = $98496c826aa59477$var$_toPrimitive(arg, "string");
    return $98496c826aa59477$var$_typeof(key) === "symbol" ? key : String(key);
}
function $98496c826aa59477$var$_toPrimitive(input, hint) {
    if ($98496c826aa59477$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($98496c826aa59477$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $98496c826aa59477$var$withUsage = (0, $b01gv.createDocumentationMessageGenerator)({
    name: 'search-box'
});
var $98496c826aa59477$var$suit = (0, $8Deqe.component)('SearchBox');
var $98496c826aa59477$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses, placeholder = _ref.placeholder, templates = _ref.templates, autofocus = _ref.autofocus, searchAsYouType = _ref.searchAsYouType, ignoreCompositionEvents = _ref.ignoreCompositionEvents, showReset = _ref.showReset, showSubmit = _ref.showSubmit, showLoadingIndicator = _ref.showLoadingIndicator;
    return function(_ref2) {
        var refine = _ref2.refine, query = _ref2.query, isSearchStalled = _ref2.isSearchStalled;
        (0, $gmem3.render)((0, $gmem3.h)((0, $aWzhI.default), {
            query: query,
            placeholder: placeholder,
            autofocus: autofocus,
            refine: refine,
            searchAsYouType: searchAsYouType,
            ignoreCompositionEvents: ignoreCompositionEvents,
            templates: templates,
            showSubmit: showSubmit,
            showReset: showReset,
            showLoadingIndicator: showLoadingIndicator,
            isSearchStalled: isSearchStalled,
            cssClasses: cssClasses
        }), containerNode);
    };
};
/**
 * The searchbox widget is used to let the user set a text based query.
 *
 * This is usually the  main entry point to start the search in an instantsearch context. For that
 * reason is usually placed on top, and not hidden so that the user can start searching right
 * away.
 *
 */ var $98496c826aa59477$var$searchBox = function searchBox(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, _ref3$placeholder = _ref3.placeholder, placeholder = _ref3$placeholder === void 0 ? '' : _ref3$placeholder, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$autofocus = _ref3.autofocus, autofocus = _ref3$autofocus === void 0 ? false : _ref3$autofocus, _ref3$searchAsYouType = _ref3.searchAsYouType, searchAsYouType = _ref3$searchAsYouType === void 0 ? true : _ref3$searchAsYouType, _ref3$ignoreCompositi = _ref3.ignoreCompositionEvents, ignoreCompositionEvents = _ref3$ignoreCompositi === void 0 ? false : _ref3$ignoreCompositi, _ref3$showReset = _ref3.showReset, showReset = _ref3$showReset === void 0 ? true : _ref3$showReset, _ref3$showSubmit = _ref3.showSubmit, showSubmit = _ref3$showSubmit === void 0 ? true : _ref3$showSubmit, _ref3$showLoadingIndi = _ref3.showLoadingIndicator, showLoadingIndicator = _ref3$showLoadingIndi === void 0 ? true : _ref3$showLoadingIndi, queryHook = _ref3.queryHook, _ref3$templates = _ref3.templates, userTemplates = _ref3$templates === void 0 ? {} : _ref3$templates;
    if (!container) throw new Error($98496c826aa59477$var$withUsage('The `container` option is required.'));
    var containerNode = (0, $aCMjd.getContainerNode)(container);
    var cssClasses = {
        root: (0, $gMP3i.cx)($98496c826aa59477$var$suit(), userCssClasses.root),
        form: (0, $gMP3i.cx)($98496c826aa59477$var$suit({
            descendantName: 'form'
        }), userCssClasses.form),
        input: (0, $gMP3i.cx)($98496c826aa59477$var$suit({
            descendantName: 'input'
        }), userCssClasses.input),
        submit: (0, $gMP3i.cx)($98496c826aa59477$var$suit({
            descendantName: 'submit'
        }), userCssClasses.submit),
        submitIcon: (0, $gMP3i.cx)($98496c826aa59477$var$suit({
            descendantName: 'submitIcon'
        }), userCssClasses.submitIcon),
        reset: (0, $gMP3i.cx)($98496c826aa59477$var$suit({
            descendantName: 'reset'
        }), userCssClasses.reset),
        resetIcon: (0, $gMP3i.cx)($98496c826aa59477$var$suit({
            descendantName: 'resetIcon'
        }), userCssClasses.resetIcon),
        loadingIndicator: (0, $gMP3i.cx)($98496c826aa59477$var$suit({
            descendantName: 'loadingIndicator'
        }), userCssClasses.loadingIndicator),
        loadingIcon: (0, $gMP3i.cx)($98496c826aa59477$var$suit({
            descendantName: 'loadingIcon'
        }), userCssClasses.loadingIcon)
    };
    var templates = $98496c826aa59477$var$_objectSpread($98496c826aa59477$var$_objectSpread({}, (0, $551Ac.default)), userTemplates);
    var specializedRenderer = $98496c826aa59477$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        placeholder: placeholder,
        templates: templates,
        autofocus: autofocus,
        searchAsYouType: searchAsYouType,
        ignoreCompositionEvents: ignoreCompositionEvents,
        showReset: showReset,
        showSubmit: showSubmit,
        showLoadingIndicator: showLoadingIndicator
    });
    var makeWidget = (0, $de57eda7dc6cba5d$export$2e2bcd8739ae039)(specializedRenderer, function() {
        return (0, $gmem3.render)(null, containerNode);
    });
    return $98496c826aa59477$var$_objectSpread($98496c826aa59477$var$_objectSpread({}, makeWidget({
        queryHook: queryHook
    })), {}, {
        $$widgetType: 'ais.searchBox'
    });
};
var $98496c826aa59477$export$2e2bcd8739ae039 = $98496c826aa59477$var$searchBox;


var $gMP3i = parcelRequire("gMP3i");

var $gmem3 = parcelRequire("gmem3");

var $gMP3i = parcelRequire("gMP3i");

var $gmem3 = parcelRequire("gmem3");
function $8b693b29b71c33a7$var$Selector(_ref) {
    var currentValue = _ref.currentValue, options = _ref.options, cssClasses = _ref.cssClasses, setValue = _ref.setValue, ariaLabel = _ref.ariaLabel;
    return (0, $gmem3.h)("select", {
        className: (0, $gMP3i.cx)(cssClasses.select),
        onChange: function onChange(event) {
            return setValue(event.target.value);
        },
        value: "".concat(currentValue),
        "aria-label": ariaLabel
    }, options.map(function(option) {
        return (0, $gmem3.h)("option", {
            className: (0, $gMP3i.cx)(cssClasses.option),
            key: option.label + option.value,
            value: "".concat(option.value)
        }, option.label);
    }));
}
var $8b693b29b71c33a7$export$2e2bcd8739ae039 = $8b693b29b71c33a7$var$Selector;



var $eG8tq = parcelRequire("eG8tq");
var $b01gv = parcelRequire("b01gv");
var $9TXzx = parcelRequire("9TXzx");
var $f3bh9 = parcelRequire("f3bh9");
function $39e69260c3dec1aa$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $39e69260c3dec1aa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $39e69260c3dec1aa$var$_typeof(obj);
}
function $39e69260c3dec1aa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $39e69260c3dec1aa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $39e69260c3dec1aa$var$ownKeys(Object(source), !0).forEach(function(key) {
            $39e69260c3dec1aa$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $39e69260c3dec1aa$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $39e69260c3dec1aa$var$_defineProperty(obj, key, value) {
    key = $39e69260c3dec1aa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $39e69260c3dec1aa$var$_toPropertyKey(arg) {
    var key = $39e69260c3dec1aa$var$_toPrimitive(arg, "string");
    return $39e69260c3dec1aa$var$_typeof(key) === "symbol" ? key : String(key);
}
function $39e69260c3dec1aa$var$_toPrimitive(input, hint) {
    if ($39e69260c3dec1aa$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($39e69260c3dec1aa$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $39e69260c3dec1aa$var$withUsage = (0, $b01gv.createDocumentationMessageGenerator)({
    name: 'sort-by',
    connector: true
});
/**
 * The **SortBy** connector provides the logic to build a custom widget that will display a
 * list of indices. With Algolia, this is most commonly used for changing ranking strategy. This allows
 * a user to change how the hits are being sorted.
 */ var $39e69260c3dec1aa$var$connectSortBy = function connectSortBy(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $f3bh9.noop);
    (0, $eG8tq.checkRendering)(renderFn, $39e69260c3dec1aa$var$withUsage());
    var connectorState = {};
    return function(widgetParams) {
        var _ref = widgetParams || {}, items = _ref.items, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(x) {
            return x;
        } : _ref$transformItems;
        if (!Array.isArray(items)) throw new Error($39e69260c3dec1aa$var$withUsage('The `items` option expects an array of objects.'));
        return {
            $$type: 'ais.sortBy',
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                var widgetRenderState = this.getWidgetRenderState(initOptions);
                var currentIndex = widgetRenderState.currentRefinement;
                var isCurrentIndexInItems = (0, $9TXzx.find)(items, function(item) {
                    return item.value === currentIndex;
                });
                renderFn($39e69260c3dec1aa$var$_objectSpread($39e69260c3dec1aa$var$_objectSpread({}, widgetRenderState), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($39e69260c3dec1aa$var$_objectSpread($39e69260c3dec1aa$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref2) {
                var state = _ref2.state;
                unmountFn();
                return connectorState.initialIndex ? state.setIndex(connectorState.initialIndex) : state;
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $39e69260c3dec1aa$var$_objectSpread($39e69260c3dec1aa$var$_objectSpread({}, renderState), {}, {
                    sortBy: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref3) {
                var results = _ref3.results, helper = _ref3.helper, state = _ref3.state, parent = _ref3.parent;
                if (!connectorState.initialIndex && parent) connectorState.initialIndex = parent.getIndexName();
                if (!connectorState.setIndex) connectorState.setIndex = function(indexName) {
                    helper.setIndex(indexName).search();
                };
                var hasNoResults = results ? results.nbHits === 0 : true;
                return {
                    currentRefinement: state.index,
                    options: transformItems(items, {
                        results: results
                    }),
                    refine: connectorState.setIndex,
                    hasNoResults: hasNoResults,
                    canRefine: !hasNoResults && items.length > 0,
                    widgetParams: widgetParams
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var currentIndex = searchParameters.index;
                return $39e69260c3dec1aa$var$_objectSpread($39e69260c3dec1aa$var$_objectSpread({}, uiState), {}, {
                    sortBy: currentIndex !== connectorState.initialIndex ? currentIndex : undefined
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                return searchParameters.setQueryParameter('index', uiState.sortBy || connectorState.initialIndex || searchParameters.index);
            }
        };
    };
};
var $39e69260c3dec1aa$export$2e2bcd8739ae039 = $39e69260c3dec1aa$var$connectSortBy;



var $8Deqe = parcelRequire("8Deqe");

var $b01gv = parcelRequire("b01gv");
var $aCMjd = parcelRequire("aCMjd");
function $de595b65ed3abd07$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $de595b65ed3abd07$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $de595b65ed3abd07$var$_typeof(obj);
}
function $de595b65ed3abd07$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $de595b65ed3abd07$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $de595b65ed3abd07$var$ownKeys(Object(source), !0).forEach(function(key) {
            $de595b65ed3abd07$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $de595b65ed3abd07$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $de595b65ed3abd07$var$_defineProperty(obj, key, value) {
    key = $de595b65ed3abd07$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $de595b65ed3abd07$var$_toPropertyKey(arg) {
    var key = $de595b65ed3abd07$var$_toPrimitive(arg, "string");
    return $de595b65ed3abd07$var$_typeof(key) === "symbol" ? key : String(key);
}
function $de595b65ed3abd07$var$_toPrimitive(input, hint) {
    if ($de595b65ed3abd07$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($de595b65ed3abd07$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $de595b65ed3abd07$var$withUsage = (0, $b01gv.createDocumentationMessageGenerator)({
    name: 'sort-by'
});
var $de595b65ed3abd07$var$suit = (0, $8Deqe.component)('SortBy');
var $de595b65ed3abd07$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses;
    return function(_ref2, isFirstRendering) {
        var currentRefinement = _ref2.currentRefinement, options = _ref2.options, refine = _ref2.refine;
        if (isFirstRendering) return;
        (0, $gmem3.render)((0, $gmem3.h)("div", {
            className: cssClasses.root
        }, (0, $gmem3.h)((0, $8b693b29b71c33a7$export$2e2bcd8739ae039), {
            cssClasses: cssClasses,
            currentValue: currentRefinement,
            options: options,
            setValue: refine,
            ariaLabel: "Sort results by"
        })), containerNode);
    };
};
/**
 * Sort by selector is a widget used for letting the user choose between different
 * indices that contains the same data with a different order / ranking formula.
 */ var $de595b65ed3abd07$var$sortBy = function sortBy(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, items = _ref3.items, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, transformItems = _ref3.transformItems;
    if (!container) throw new Error($de595b65ed3abd07$var$withUsage('The `container` option is required.'));
    var containerNode = (0, $aCMjd.getContainerNode)(container);
    var cssClasses = {
        root: (0, $gMP3i.cx)($de595b65ed3abd07$var$suit(), userCssClasses.root),
        select: (0, $gMP3i.cx)($de595b65ed3abd07$var$suit({
            descendantName: 'select'
        }), userCssClasses.select),
        option: (0, $gMP3i.cx)($de595b65ed3abd07$var$suit({
            descendantName: 'option'
        }), userCssClasses.option)
    };
    var specializedRenderer = $de595b65ed3abd07$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses
    });
    var makeWidget = (0, $39e69260c3dec1aa$export$2e2bcd8739ae039)(specializedRenderer, function() {
        return (0, $gmem3.render)(null, containerNode);
    });
    return $de595b65ed3abd07$var$_objectSpread($de595b65ed3abd07$var$_objectSpread({}, makeWidget({
        container: containerNode,
        items: items,
        transformItems: transformItems
    })), {}, {
        $$widgetType: 'ais.sortBy'
    });
};
var $de595b65ed3abd07$export$2e2bcd8739ae039 = $de595b65ed3abd07$var$sortBy;


var $bMEbC = parcelRequire("bMEbC");

var $2novD = parcelRequire("2novD");

var $cZDdp = parcelRequire("cZDdp");
var $eb36d9616fc15e97$exports = {};
var $84b51fa0ad41c095$exports = {};

$84b51fa0ad41c095$exports = (parcelRequire("4h0xY")).getBundleURL('ju1jN') + "amazon_icon.637b370d.svg";


var $f2bc30eb12af0d5f$exports = {};

$f2bc30eb12af0d5f$exports = (parcelRequire("4h0xY")).getBundleURL('ju1jN') + "archive_icon.b93ca50a.svg";


var $5b4d68b115acf2a4$exports = {};

$5b4d68b115acf2a4$exports = (parcelRequire("4h0xY")).getBundleURL('ju1jN') + "generic_link_icon.3aa6c58d.svg";


var $82e12571e583a88b$exports = {};

$82e12571e583a88b$exports = (parcelRequire("4h0xY")).getBundleURL('ju1jN') + "king-james-bible-kjv.ddcb2585.png";


var $d5742470cb4ca9fe$exports = {};

$d5742470cb4ca9fe$exports = (parcelRequire("4h0xY")).getBundleURL('ju1jN') + "king-james-bible-online.46b885d6.png";


var $15f6bf5383d5a1c3$exports = {};

$15f6bf5383d5a1c3$exports = (parcelRequire("4h0xY")).getBundleURL('ju1jN') + "kjv-logo.14aaa2a7.png";


var $1dc7a9a15bb34f46$exports = {};

$1dc7a9a15bb34f46$exports = (parcelRequire("4h0xY")).getBundleURL('ju1jN') + "open-bible.d0b47fbd.png";


var $6830e0ed12af9394$exports = {};

$6830e0ed12af9394$exports = (parcelRequire("4h0xY")).getBundleURL('ju1jN') + "opengraph_banner.c6e2d394.png";


var $55bfbde18dd6ea18$exports = {};

$55bfbde18dd6ea18$exports = (parcelRequire("4h0xY")).getBundleURL('ju1jN') + "typesense.3867b908.svg";


$eb36d9616fc15e97$exports = {
    "amazon_icon": {
        "svg": $84b51fa0ad41c095$exports
    },
    "archive_icon": {
        "svg": $f2bc30eb12af0d5f$exports
    },
    "generic_link_icon": {
        "svg": $5b4d68b115acf2a4$exports
    },
    "king-james-bible-kjv": {
        "png": $82e12571e583a88b$exports
    },
    "king-james-bible-online": {
        "png": $d5742470cb4ca9fe$exports
    },
    "kjv-logo": {
        "png": $15f6bf5383d5a1c3$exports
    },
    "open-bible": {
        "png": $1dc7a9a15bb34f46$exports
    },
    "opengraph_banner": {
        "png": $6830e0ed12af9394$exports
    },
    "typesense": {
        "svg": $55bfbde18dd6ea18$exports
    }
};


var $eb82dc9c3dda9df7$exports = {};
$eb82dc9c3dda9df7$exports = JSON.parse("[\"a\",\"am\",\"an\",\"and\",\"as\",\"at\",\"by\",\"c's\",\"co\",\"do\",\"de\",\"eg\",\"et\",\"for\",\"he\",\"hi\",\"i\",\"i'd\",\"i'm\",\"ie\",\"if\",\"in\",\"inc\",\"is\",\"it\",\"its\",\"me\",\"my\",\"nd\",\"no\",\"non\",\"nor\",\"not\",\"of\",\"off\",\"oh\",\"ok\",\"on\",\"or\",\"per\",\"que\",\"qv\",\"rd\",\"re\",\"so\",\"sub\",\"t's\",\"th\",\"the\",\"to\",\"too\",\"two\",\"un\",\"up\",\"us\",\"vs\",\"we\"]");


window.$ = (0, (/*@__PURE__*/$parcel$interopDefault($isndi))); // workaround for https://github.com/parcel-bundler/parcel/issues/333
// Source: https://stackoverflow.com/a/901144/123545
const $e57609b49b70c4aa$var$anchorParams = new Proxy(new URLSearchParams(window.location.hash.replace("#", "")), {
    get: (anchorParams, prop)=>anchorParams.get(prop)
});
let $e57609b49b70c4aa$var$TYPESENSE_SERVER_CONFIG = {
    apiKey: "3FE6XjoV2QHVjUyVdXs4eh4aw8MduZY8",
    nodes: [
        {
            host: $e57609b49b70c4aa$var$anchorParams.host ? $e57609b49b70c4aa$var$anchorParams.host : "searchbible.net",
            port: "443",
            protocol: "https",
            path: '/api/ts' // <- ADD this new line (no comma needed after)
        }
    ],
    numRetries: 8,
    useServerSideSearchCache: false
};
const $e57609b49b70c4aa$var$INDEX_NAME = "kjvbible2026";
async function $e57609b49b70c4aa$var$getIndexSize() {
    let typesenseSearchClient = new (0, $cZDdp.SearchClient)({
        ...$e57609b49b70c4aa$var$TYPESENSE_SERVER_CONFIG,
        useServerSideSearchCache: true
    });
    let results = await typesenseSearchClient.collections($e57609b49b70c4aa$var$INDEX_NAME).documents().search({
        q: "*"
    });
    return results["found"];
}
let $e57609b49b70c4aa$var$indexSize;
(async ()=>{
    $e57609b49b70c4aa$var$indexSize = await $e57609b49b70c4aa$var$getIndexSize();
})();
function $e57609b49b70c4aa$var$iconForUrl(url) {
    if (url.includes("amazon.com")) return (0, (/*@__PURE__*/$parcel$interopDefault($eb36d9616fc15e97$exports)))["amazon_icon"]["svg"];
    else if (url.includes("openlibrary")) return (0, (/*@__PURE__*/$parcel$interopDefault($eb36d9616fc15e97$exports)))["archive_icon"]["svg"];
    else return (0, (/*@__PURE__*/$parcel$interopDefault($eb36d9616fc15e97$exports)))["generic_link_icon"]["svg"];
}
function $e57609b49b70c4aa$var$topMarginForUrl(url) {
    if (url.includes("amazon.com")) return 1;
    else return 0;
}
function $e57609b49b70c4aa$var$urlsObjectsForBookObject(bookObject) {
    let urls = [];
    /*
  if (bookObject["isbn_10"]) {
    urls.push(`https://www.amazon.com/dp/${bookObject["isbn_10"]}`);
  } else if (bookObject.isbn_13) {
    urls.push(`https://www.amazon.com/s?k=${bookObject["isbn_13"]}`);
  }
*/ urls.push(`https://www.kingjamesbibleonline.org/search.php?q=${bookObject["id"]}`);
    /*urls.push(`https://openlibrary.org${bookObject["id"]}`);*/ return urls.map((u)=>{
        return {
            url: u,
            icon: $e57609b49b70c4aa$var$iconForUrl(u),
            topMargin: $e57609b49b70c4aa$var$topMarginForUrl(u)
        };
    });
}
function $e57609b49b70c4aa$var$queryWithoutStopWords(query) {
    const words = query.replace(/[&/\\#,+()$~%.':*?<>{}]/g, "").split(" ");
    return words.map((word)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eb82dc9c3dda9df7$exports))).includes(word.toLowerCase())) return null;
        else return word;
    }).filter((w)=>w).join(" ").trim();
}
const $e57609b49b70c4aa$var$typesenseInstantsearchAdapter = new (0, (/*@__PURE__*/$parcel$interopDefault($2novD)))({
    server: $e57609b49b70c4aa$var$TYPESENSE_SERVER_CONFIG,
    // The following parameters are directly passed to Typesense's search API endpoint.
    //  So you can pass any parameters supported by the search endpoint below.
    //  queryBy is required.
    additionalSearchParameters: {
        query_by: "vtext,titles,names",
        facet_sample_threshold: 1000,
        facet_sample_percent: 20
    }
});
const $e57609b49b70c4aa$var$searchClient = $e57609b49b70c4aa$var$typesenseInstantsearchAdapter.searchClient;
const $e57609b49b70c4aa$var$search = (0, $dZhcI.default)({
    searchClient: $e57609b49b70c4aa$var$searchClient,
    indexName: $e57609b49b70c4aa$var$INDEX_NAME,
    initialUiState: {
        [$e57609b49b70c4aa$var$INDEX_NAME]: {
            refinementList: {
                bsect: [
                    'O',
                    'N'
                ]
            }
        }
    },
    onStateChange ({ uiState: uiState, setUiState: setUiState }) {
        const query = (uiState[$e57609b49b70c4aa$var$INDEX_NAME] && uiState[$e57609b49b70c4aa$var$INDEX_NAME].query ? uiState[$e57609b49b70c4aa$var$INDEX_NAME].query : "").trim();
        $("#results-section").toggleClass("has-query", query !== "");
        setUiState(uiState);
    },
    future: {
        preserveSharedStateOnUnmount: true
    }
});
const $e57609b49b70c4aa$var$analyticsMiddleware = ()=>{
    return {
        onStateChange () {
        /*window.ga(
        "set",
        "page",
        (window.location.pathname + window.location.search).toLowerCase()
      );
      window.ga("send", "pageView");
	  */ },
        subscribe () {},
        unsubscribe () {}
    };
};
$e57609b49b70c4aa$var$search.use($e57609b49b70c4aa$var$analyticsMiddleware);
let $e57609b49b70c4aa$var$debounceTimerId;
$e57609b49b70c4aa$var$search.addWidgets([
    (0, $98496c826aa59477$export$2e2bcd8739ae039)({
        container: "#searchbox",
        showSubmit: true,
        showReset: true,
        placeholder: "Type in Bible verses or search words here...",
        autofocus: true,
        cssClasses: {
            input: "form-control searchbox-input"
        },
        queryHook (query, search) {
            const modifiedQuery = query;
            /* const modifiedQuery = queryWithoutStopWords(query); */ /*this removes stopwords from query*/ if (modifiedQuery.trim() !== "" && modifiedQuery.trim().length > 2) {
                if ($e57609b49b70c4aa$var$debounceTimerId) clearTimeout($e57609b49b70c4aa$var$debounceTimerId);
                $e57609b49b70c4aa$var$debounceTimerId = setTimeout(()=>search(modifiedQuery), 250);
            }
        }
    }),
    (0, $bMEbC.default)({
        container: "#stats",
        templates: {
            text: ({ nbHits: nbHits, hasNoResults: hasNoResults, hasOneResult: hasOneResult, processingTimeMS: processingTimeMS })=>{
                let statsText = "";
                if (hasNoResults) statsText = "No results";
                else if (hasOneResult) statsText = "1 result";
                else statsText = `${nbHits.toLocaleString()} results`;
                return `${statsText} in ${processingTimeMS}ms`;
            }
        }
    }),
    (0, $6UOpb.default)({
        container: "#hits",
        cssClasses: {
            list: "list-unstyled",
            item: "result-item",
            loadMore: "btn btn-primary mx-auto d-block mt-4"
        },
        templates: {
            item: (hit, { html: html, components: components })=>html`
        <article class="result-row" data-verse-id="${hit.bname}-${hit.cnum}-${hit.vnum}" data-reference="${hit.bname} ${hit.cnum}:${hit.vnum}" data-url="https://www.kingjamesbibleonline.org/${hit.bname.replace(/ /g, '-')}-${hit.cnum}-${hit.vnum}/">
          <button type="button" class="result-bookmark save-verse" aria-label="Save ${hit.bname} ${hit.cnum}:${hit.vnum}">♡</button>
          <div class="result-heading">
            <a class="result-reference" href="https://www.kingjamesbibleonline.org/${hit.bname.replace(/ /g, '-')}-${hit.cnum}-${hit.vnum}/" target="_blank" rel="noopener">
              ${hit.bname} ${hit.cnum}:${hit.vnum}
            </a>
            <div class="result-actions" aria-label="Verse actions">
              <a class="chapter-link" href="https://www.kingjamesbibleonline.org/${hit.bname.replace(/ /g, '-')}-${hit.cnum}/" target="_blank" rel="noopener">chapter</a>
              <a class="context-link" href="https://www.kingjamesbibleonline.org/${hit.bname.replace(/ /g, '-')}-${hit.cnum}-${hit.vnum}/" target="_blank" rel="noopener">context</a>
              <a class="similar-meaning-link" href="https://www.kingjamesbibleonline.org/search.php?hs=1&q=${encodeURIComponent(hit.vtext)}" target="_blank" rel="noopener">similar meaning</a>
              <button type="button" class="copy-verse">copy</button>
              <button type="button" class="save-verse text-save">save</button>
            </div>
          </div>
          <span class="result-text">${components.Highlight({
                    hit: hit,
                    attribute: "vtext"
                })}</span>
        </article>
      `,
            empty: (state, { html: html })=>html`No results found for <q>${state.query}</q>. Please try another search term.`
        },
        transformItems: (items)=>{
            return items.map((item)=>{
                return {
                    ...item,
                    urls: $e57609b49b70c4aa$var$urlsObjectsForBookObject(item)
                };
            });
        }
    }),
    (0, $2hZw3.default)({
        container: "#author-refinement-list",
        attribute: "titles",
        searchable: true,
        searchablePlaceholder: "Search by story",
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            searchableInput: "form-control form-control-sm mb-2 border-light-2",
            searchableSubmit: "d-none",
            searchableReset: "d-none",
            showMore: "btn btn-secondary btn-sm align-content-center",
            list: "list-unstyled",
            count: "badge bg-light text-bg-light ms-2",
            label: "d-flex align-items-center text-capitalize mb-2",
            checkbox: "me-2"
        }
    }),
    (0, $2hZw3.default)({
        container: "#subjects-refinement-list",
        attribute: "names",
        searchable: true,
        searchablePlaceholder: "Search names",
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            searchableInput: "form-control form-control-sm mb-2 border-light-2",
            searchableSubmit: "d-none",
            searchableReset: "d-none",
            showMore: "btn btn-secondary btn-sm align-content-center",
            list: "list-unstyled",
            count: "badge bg-light text-bg-light ms-2",
            label: "d-flex align-items-center text-capitalize mb-2",
            checkbox: "me-2"
        }
    }),
    (0, $2hZw3.default)({
        container: "#topics-refinement-list",
        attribute: "topics",
        searchable: true,
        searchablePlaceholder: "Search topics",
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            searchableInput: "form-control form-control-sm mb-2 border-light-2",
            searchableSubmit: "d-none",
            searchableReset: "d-none",
            showMore: "btn btn-secondary btn-sm align-content-center",
            list: "list-unstyled",
            count: "badge bg-light text-bg-light ms-2",
            label: "d-flex align-items-center text-capitalize mb-2",
            checkbox: "me-2"
        }
    }),
    (0, $2hZw3.default)({
        container: "#emojis-refinement-list",
        attribute: "emojis",
        searchable: true,
        searchablePlaceholder: "Search emojis",
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            searchableInput: "form-control form-control-sm mb-2 border-light-2",
            searchableSubmit: "d-none",
            searchableReset: "d-none",
            showMore: "btn btn-secondary btn-sm align-content-center",
            list: "list-unstyled",
            count: "badge bg-light text-bg-light ms-2",
            label: "d-flex align-items-center text-capitalize mb-2",
            checkbox: "me-2"
        }
    }),
    (0, $2hZw3.default)({
        container: "#place-refinement-list",
        attribute: "place",
        searchable: true,
        searchablePlaceholder: "Search places",
        showMore: true,
        showMoreLimit: 40,
        cssClasses: {
            searchableInput: "form-control form-control-sm mb-2 border-light-2",
            searchableSubmit: "d-none",
            searchableReset: "d-none",
            showMore: "btn btn-secondary btn-sm align-content-center",
            list: "list-unstyled",
            count: "badge bg-light text-bg-light ms-2",
            label: "d-flex align-items-center text-capitalize mb-2",
            checkbox: "me-2"
        }
    }),
    (0, $ieTBU.default)({
        hitsPerPage: 20
    }),
    (0, $de595b65ed3abd07$export$2e2bcd8739ae039)({
        container: "#sort-by",
        items: [
            {
                label: "Relevance",
                value: `${$e57609b49b70c4aa$var$INDEX_NAME}`
            },
            {
                label: "Book Order A-Z",
                value: `${$e57609b49b70c4aa$var$INDEX_NAME}/sort/vid:asc`
            },
            {
                label: "Book Order Z-A",
                value: `${$e57609b49b70c4aa$var$INDEX_NAME}/sort/vid:desc`
            },
            {
                label: "Alphabetical A-Z",
                value: `${$e57609b49b70c4aa$var$INDEX_NAME}/sort/bnum:asc`
            },
            {
                label: "Alphabetical Z-A",
                value: `${$e57609b49b70c4aa$var$INDEX_NAME}/sort/bnum:desc`
            }
        ],
        cssClasses: {
            select: "form-select form-select-sm"
        }
    }),
    (0, $emBps.default)({
        container: "#current-refinements",
        cssClasses: {
            list: "list-unstyled",
            label: "d-none",
            item: "h5",
            category: "badge bg-light text-bg-light px-3 m-2",
            categoryLabel: "text-capitalize",
            delete: "btn btn-sm btn-link p-0 ps-2"
        },
        transformItems: (items)=>{
            const modifiedItems = items.map((item)=>{
                return {
                    ...item,
                    label: ""
                };
            });
            return modifiedItems;
        }
    })
]);
function $e57609b49b70c4aa$var$handleSearchTermClick(event) {
    const $searchBox = $("#searchbox input[type=search]");
    $(document).on("submit", ".ais-SearchBox-form", function(event) {
        event.preventDefault();
    });
    $e57609b49b70c4aa$var$search.helper.clearRefinements();
    $searchBox.val(event.currentTarget.textContent);
    $e57609b49b70c4aa$var$search.helper.setQuery($searchBox.val()).search();
}
$e57609b49b70c4aa$var$search.on("render", function() {
    // Make author names clickable
    $("#hits .clickable-search-term").on("click", $e57609b49b70c4aa$var$handleSearchTermClick);
    // Read directions button
    $(".readDirectionsButton").on("click", (event)=>{
        $(event.currentTarget).parent().siblings().first().modal("show");
    });
});
$e57609b49b70c4aa$var$search.start();
$(function() {
    const $searchBox = $("#searchbox input[type=search]");
    // Testament filter checkboxes
    function updateTestamentFilter() {
        const parts = [];
        if ($("#chk-old").is(":checked")) parts.push("bsect:O");
        if ($("#chk-new").is(":checked")) parts.push("bsect:N");
        if ($("#chk-apocrypha").is(":checked")) parts.push("bsect:A");
        const filterStr = parts.length ? parts.join(" || ") : "bsect:O || bsect:N";
        $e57609b49b70c4aa$var$search.helper.setQueryParameter("filters", filterStr).search();
    }
    $("#chk-old, #chk-new, #chk-apocrypha").on("change", updateTestamentFilter);
    // Apply default testament filter on load
    $e57609b49b70c4aa$var$search.helper.setQueryParameter("filters", "bsect:O || bsect:N");
    // Search on page refresh with the query restored from URL params
    $("#results-section").toggleClass("has-query", $searchBox.val().trim() !== "");
    if ($searchBox.val().trim() !== "") $e57609b49b70c4aa$var$search.helper.setQuery($searchBox.val()).search();
    // Handle example search terms
    $(".clickable-search-term").on("click", $e57609b49b70c4aa$var$handleSearchTermClick);
    // Clear refinements, when searching (but preserve testament filter)
    $searchBox.on("keydown", ()=>{
        $e57609b49b70c4aa$var$search.helper.clearRefinements('titles').clearRefinements('names').clearRefinements('topics').clearRefinements('emojis').clearRefinements('place');
    });
    if (!matchMedia("(min-width: 768px)").matches) $searchBox.on("focus, keydown", ()=>{
        $("html, body").animate({
            scrollTop: $("#searchbox-container").offset().top
        }, 500);
    });
    $("#clear-search-page").on("click", ()=>{
        window.location.replace(window.location.origin + window.location.pathname);
    });
    $("#smart-toggle").on("click", function() {
        const pressed = $(this).attr("aria-pressed") === "true";
        $(this).attr("aria-pressed", String(!pressed)).toggleClass("is-smart", !pressed);
    });
    const FAVORITES_KEY = "kjvSavedVerses";
    function readSavedVerses() {
        try {
            return JSON.parse(localStorage.getItem(FAVORITES_KEY) || "[]");
        } catch (e) {
            return [];
        }
    }
    function writeSavedVerses(items) {
        localStorage.setItem(FAVORITES_KEY, JSON.stringify(items));
    }
    function verseTextFromRow($row) {
        return $row.find(".result-text").text().replace(/\s+/g, " ").trim();
    }
    function updateSavedButtons() {
        const savedIds = new Set(readSavedVerses().map((item)=>item.id));
        $(".result-row").each(function() {
            const $row = $(this);
            const isSaved = savedIds.has($row.data("verse-id"));
            $row.find(".save-verse").toggleClass("is-saved", isSaved);
            $row.find(".result-bookmark").text(isSaved ? "\u2665" : "\u2661");
            $row.find(".text-save").text(isSaved ? "saved" : "save");
        });
    }
    function toggleSavedVerse($row) {
        const id = $row.data("verse-id");
        const reference = $row.data("reference");
        const url = $row.data("url");
        const text = verseTextFromRow($row);
        let saved = readSavedVerses();
        if (saved.some((item)=>item.id === id)) saved = saved.filter((item)=>item.id !== id);
        else saved.unshift({
            id: id,
            reference: reference,
            text: text,
            url: url,
            savedAt: Date.now()
        });
        writeSavedVerses(saved);
        updateSavedButtons();
    }
    function renderSavedVerses() {
        const saved = readSavedVerses();
        const $list = $("#saved-verses-list");
        if (!saved.length) {
            $list.html('<p class="saved-empty">No saved verses yet. Use the heart or Save link beside a verse to add it here.</p>');
            return;
        }
        $list.html(saved.map((item)=>`
      <article class="saved-verse-item">
        <a class="saved-reference" href="${item.url}" target="_blank" rel="noopener">${item.reference}</a>
        <p>${item.text}</p>
        <button type="button" class="remove-saved-verse" data-verse-id="${item.id}">Remove</button>
      </article>
    `).join(""));
    }
    $(document).on("click", ".save-verse", function() {
        toggleSavedVerse($(this).closest(".result-row"));
    });
    $(document).on("click", ".copy-verse", async function() {
        const $row = $(this).closest(".result-row");
        const copyText = `${$row.data("reference")} ${verseTextFromRow($row)}`;
        try {
            await navigator.clipboard.writeText(copyText);
            $(this).text("copied");
            setTimeout(()=>$(this).text("copy"), 1200);
        } catch (e) {
            window.prompt("Copy this verse:", copyText);
        }
    });
    $(document).on("click", ".similar-meaning", function() {
        const text = verseTextFromRow($(this).closest(".result-row"));
        const $searchBox = $("#searchbox input[type=search]");
        $e57609b49b70c4aa$var$search.helper.clearRefinements();
        $searchBox.val(text);
        $e57609b49b70c4aa$var$search.helper.setQuery(text).search();
    });
    $("#saved-verses-link").on("click", function(event) {
        event.preventDefault();
        renderSavedVerses();
        $("#savedVersesModal").modal("show");
    });
    $(document).on("click", ".remove-saved-verse", function() {
        const id = $(this).data("verse-id");
        writeSavedVerses(readSavedVerses().filter((item)=>item.id !== id));
        renderSavedVerses();
        updateSavedButtons();
    });
    $e57609b49b70c4aa$var$search.on("render", updateSavedButtons);
    updateSavedButtons();
});

})();
//# sourceMappingURL=index.03ddc4c1.js.map
